import { notifyParent } from 'mailup-react-helpers'
import { useIntl } from 'react-intl'
import { useRecoilValue, useResetRecoilState } from 'recoil'

import {
  Button,
  BUTTON_VARIANT_SECONDARY,
  Grid,
  GridCell,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  SPACING_8,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD,
  TruncateAndTooltip
} from 'mailup-web-components'

import { modalFilterDetailsState } from 'Pages/Campaign/recoil/state/modals'

const ModalFilterDetails = () => {
  const intl = useIntl()

  const { show, type, name, description, id } = useRecoilValue(
    modalFilterDetailsState
  )
  const resetModal = useResetRecoilState(modalFilterDetailsState)

  const handleClickConfirm = () => {
    notifyParent('redirectMainFrame', [
      `filters_app_redirector.aspx?r=${encodeURIComponent(`/filters/form/${id}`)}`
    ])
  }

  return (
    <Modal
      show={show}
      onClose={resetModal}
      data-mu-test='campaign__step-3__modal-filter-details'
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.SearchRecipients.EditFilterFilterTitle'
        })}
      />
      <ModalBody>
        <Grid cols={12}>
          <GridCell span={3}>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterType'
              })}
            </Text>
          </GridCell>
          <GridCell span={9}>{type}</GridCell>
        </Grid>
        <SpacingVertical variant={SPACING_8} />
        <Grid cols={12}>
          <GridCell span={3}>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterName'
              })}
            </Text>
          </GridCell>
          <GridCell span={9}>
            <TruncateAndTooltip text={`${id} - ${name}`} />
          </GridCell>
        </Grid>
        <SpacingVertical variant={SPACING_8} />
        <Grid cols={12}>
          <GridCell span={3}>
            <Text variant={TEXT_VARIANT_BOLD}>
              {intl.formatMessage({
                id: 'Load.SearchRecipients.EditFilterFilterConditions'
              })}
            </Text>
          </GridCell>
          <GridCell span={9}>{description}</GridCell>
        </Grid>
      </ModalBody>

      <ModalFoot>
        <Button kind={BUTTON_VARIANT_SECONDARY} onClick={resetModal}>
          {intl.formatMessage({
            id: 'Load.SearchRecipients.EditFilterCloseButton'
          })}
        </Button>
        <Button kind={BUTTON_VARIANT_SECONDARY} onClick={handleClickConfirm}>
          {intl.formatMessage({
            id: 'Load.SearchRecipients.EditFilterEditButton'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalFilterDetails
